<template>
  <div v-show="isActive" :key="title" class="lp-tabs-body">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { inject, Ref, ref, toRefs } from 'vue'
import { Tab } from './types'

defineOptions({
  name: 'lp-tab',
})

type Props = {
  title?: string
  disabled?: boolean
  onClick?: () => void
}
const props = withDefaults(defineProps<Props>(), {
  title: '',
  disabled: false,
  onClick: () => true,
})

const tabs = inject('tabs') as Ref<Tab[]>
const isActive = ref(false)
tabs.value.push({ ...toRefs(props), isActive })
</script>
